import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLocale } from '../../contexts/LocaleContext';
import { Card, CardHeader, CardTitle } from '../ui/card';
import { Link } from '../ui/link';
import { AdminAccessDenied } from './AdminAccessDenied';
import { ADMIN_NAV_ITEMS } from './admin-nav';

export const Admin: React.FC = () => {
  const { user } = useAuth();
  const { t } = useLocale();

  if (!user || !user.admin) {
    return <AdminAccessDenied />;
  }

  const sections = ADMIN_NAV_ITEMS.filter((item) => item.to !== '/admin');

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {sections.map((item) => {
        const Icon = item.icon;
        return (
          <Link key={item.to} to={item.to} className="block">
            <Card className="transition-colors hover:bg-muted/50">
              <CardHeader className="flex flex-row items-center gap-3 space-y-0 p-5">
                <Icon className="h-5 w-5 text-secondary-foreground" />
                <CardTitle className="text-base font-medium">{t(item.labelKey)}</CardTitle>
              </CardHeader>
            </Card>
          </Link>
        );
      })}
    </div>
  );
};
